import { Box, Typography } from "@mui/material";
import { CompetitionBox } from "./CompetitionBox";
import { useTranslation } from "../../../../../hooks/useTranslation";

type CompetitionDisplayProps = {
  buyboxPrice: number;
  buyboxIsWon: boolean;
  buyboxPercentage: number;
  lowestPrice: number;
  lowestIsWon: boolean;
  lowestPercentage: number;
  totalOfferCount: number;
};

export const CompetitionDisplay = (props: CompetitionDisplayProps) => {
  const {
    buyboxPrice,
    buyboxIsWon,
    buyboxPercentage,
    lowestPrice,
    lowestIsWon,
    lowestPercentage,
    totalOfferCount,
  } = props;

  const { translate } = useTranslation(
    "pages.inventoryManagement.inventory.list.fields.competitionDisplay",
  );

  return (
    <Box height="100%" alignContent="center">
      <CompetitionBox
        title="Buy Box"
        price={buyboxPrice}
        isWon={buyboxIsWon}
        percentage={buyboxPercentage}
      />
      <CompetitionBox
        title="Lowest"
        price={lowestPrice}
        isWon={lowestIsWon}
        percentage={lowestPercentage}
      />
      <Box
        sx={{
          display: "flex",
          borderRadius: "4px",
          padding: "0 4px",
          width: "fit-content",
          border: "1px solid",
          borderColor: (theme) => theme.palette.primary.main,
        }}
      >
        <Typography variant="caption" color="primary">
          {translate("sellerCount")} {totalOfferCount}
        </Typography>
      </Box>
    </Box>
  );
};
